import React from "react";
import { FaCheck, FaPlay, FaUser } from "react-icons/fa";
import { Link, useHistory } from "react-router-dom";
import BaseEndpoint from "../endpoints/baseEndpoint";
import useAuthUser from "../hooks/useAuthUser";

export default function StartButton({
    version,
    answer,
    disabled = false,
    onStart,
    params,
}) {
    const router = useHistory();
    const { user } = useAuthUser();

    const start = (param) => {
        localStorage.removeItem("session");
        localStorage.removeItem("answer");
        localStorage.removeItem("mapping");
        router.push(
            "/app/start" + (param ? `?id=${param.id}` : "")
        );
    };

    const handleStart = (param) => {
        localStorage.removeItem("session");
        localStorage.removeItem("answer");
        localStorage.removeItem("mapping");
        if (onStart) {
            onStart();
        } else {
            start(param);
        }
    };

    if (null !== answer) {
        if (
            !answer ||
            version === "potensi-kerja" ||
            version === "tes-akademik" ||
            version === "spesial-potential-test" ||
            version === "potential-test"
        ) {
            switch (version) {
                case "potential-test":
                    return (
                        <>
                            <div className="d-flex justify-content-center mt-5">
                                <button
                                    onClick={() => start()}
                                    className={`mx-auto btn btn-lg ${disabled ? "bg-secondary" : "btn-primary"
                                        } text-white d-inline-flex justify-content-center align-items-center`}
                                    disabled={disabled}
                                >
                                    {disabled ? (
                                        <>
                                            <FaPlay className="inline-block me-3" />{" "}
                                            Ujian belum tersedia
                                        </>
                                    ) : (
                                        <>
                                            <FaPlay className="inline-block me-3" />{" "}
                                            Mulai Ujian
                                        </>
                                    )}
                                </button>
                            </div>
                            {answer && (
                                <div className="d-flex justify-content-center mt-4">
                                    <Link to="/app/finish" className="mx-auto btn btn-lg btn-success text-white d-inline-flex justify-content-center align-items-center">
                                        <FaCheck className="inline-block me-3" /> Lihat Hasil Ujian
                                    </Link>
                                </div>
                            )}
                        </>
                    );
                case "potensi-kerja":
                    return (
                        <>
                            <div className="tw-flex tw-gap-[1rem] tw-w-[40%] tw-mx-auto mt-5">
                                {params?.session?.map((item, index) => (
                                    <button
                                        key={index}
                                        onClick={() =>
                                            start({
                                                id: item.id,
                                            })
                                        }
                                        className={`mx-auto btn btn-lg ${disabled
                                            ? "btn-secondary text-white"
                                            : "btn-primary text-white"
                                            } d-inline-flex justify-content-center align-items-center`}
                                        disabled={disabled}
                                    >
                                        <FaPlay className="inline-block me-3" />{" "}
                                        {item.name}
                                    </button>
                                ))}
                            </div>
                            {disabled && (
                                <div className="d-flex justify-content-center mt-3">
                                    <p className="text-danger fw-bold">Limit pengerjaan sudah habis / ujian belum tersedia.</p>
                                </div>
                            )}
                            {answer && (
                                <div className="tw-flex tw-justify-center mt-4">
                                    <Link
                                        to="/app/finish"
                                        className="mx-auto btn btn-lg btn-success text-white"
                                    >
                                        <FaCheck className="inline-block me-3" />{" "}
                                        Lihat Hasil Ujian
                                    </Link>
                                </div>
                            )}
                        </>
                    );
                case "tes-akademik":
                    return (
                        <>
                            <div className="d-flex justify-content-center mt-5">
                                <button
                                    onClick={() => handleStart()}
                                    className={`mx-auto btn btn-lg ${disabled ? "btn-secondary" : "btn-primary"} text-white d-inline-flex justify-content-center align-items-center`}
                                    disabled={disabled}
                                >
                                    <FaPlay className="inline-block me-3" /> Mulai
                                    Ujian
                                </button>
                            </div>
                            {disabled && (
                                <div className="d-flex justify-content-center mt-3">
                                    <p className="text-danger fw-bold">Limit pengerjaan sudah habis / ujian belum tersedia.</p>
                                </div>
                            )}
                            {answer && (
                                <div className="d-flex justify-content-center mt-4">
                                    <Link to="/app/finish" className="mx-auto btn btn-lg btn-success text-white d-inline-flex justify-content-center align-items-center">
                                        <FaCheck className="inline-block me-3" /> Lihat Hasil Ujian
                                    </Link>
                                </div>
                            )}
                        </>
                    );
                case "spesial-potential-test":
                    return (
                        <>
                            <div className="d-flex justify-content-center mt-5">
                                <button
                                    onClick={() => handleStart()}
                                    className={`mx-auto btn btn-lg ${disabled ? "btn-secondary" : "btn-primary"} text-white d-inline-flex justify-content-center align-items-center`}
                                    disabled={disabled}
                                >
                                    <FaPlay className="inline-block me-3" /> Mulai Ujian
                                </button>
                            </div>
                            {answer && (
                                <div className="d-flex justify-content-center mt-4">
                                    <Link to="/app/finish" className="mx-auto btn btn-lg btn-success text-white d-inline-flex justify-content-center align-items-center">
                                        <FaCheck className="inline-block me-3" /> Lihat Hasil Ujian
                                    </Link>
                                </div>
                            )}
                        </>
                    );
                default:
                    return;
            }
        } else {
            return (
                <div className="d-flex flex-column align-items-center mt-5">
                    <Link
                        to="/app/finish"
                        className="mx-auto btn btn-lg btn-success text-white d-inline-flex justify-content-center align-items-center"
                        style={{ minWidth: "200px" }}
                    >
                        <FaCheck className="inline-block me-3" /> Lihat Hasil Ujian
                    </Link>
                </div>
            );
        }
    } else {
        return (
            <button
                className="mx-auto btn btn-lg btn-secondary text-white d-inline-flex justify-content-center align-items-center"
                disabled
            >
                <FaUser className="inline-block me-3" /> Memuat...
            </button>
        );
    }
}
